import React from "react";
import platforms from "../data/platforms";
import KnowMoreAboutShinzura from "./KnowMoreAboutShinzura";
import AvailableOn from "./AvailableOn";
import Testimonials from "./Testimonials";

const Footer = () => {
  return (
    <footer className="text-white body-font bg-black">
    <Testimonials/>
    <AvailableOn/>
    <div className="container px-5 pb-14 md:py-12 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-nowrap flex-wrap flex-col justify-between">
      <div className="flex-grow flex flex-wrap -mb-10 md:mt-0 mt-10 text-left justify-between w-full">
      <div className="lg:w-1/4 w-1/2 px-2">
        <h2 className="title-font font-medium text-white tracking-widest text-sm mb-3">Find Us On</h2>
        <nav className="list-none mb-10">
        <ul>
          {platforms.map((platform) => (
            <li key={platform.name}>
              <a href={platform.link} className="text-white hover:text-gray-400" >{platform.name}</a>
            </li>
          ))}
          </ul>
        </nav>
      </div>
       <div className="lg:w-1/4 w-1/2 px-2">
          <h2 className="title-font font-medium text-white tracking-widest text-sm mb-3">Quick Links</h2>
          <nav className="list-none mb-10">
          <ul>
            <li><a href="/" className="text-white hover:text-gray-400">Home</a></li>
            <li><a href="/blogs" className="text-white hover:text-gray-400">Blogs</a></li>
            <li><a href="/about-us" className="text-white hover:text-gray-400">About us</a></li>
            <li><a href="/products" className="text-white hover:text-gray-400">Our Products</a></li>
            <li><a href="/combos" className="text-white hover:text-gray-400">Combos & Packs</a></li>
            </ul>
          </nav>
        </div>
        
        <div className="lg:w-1/5 sm:w-1/2 w-full px-2">
            <h2 className="title-font font-medium text-white tracking-widest text-sm mb-3">More Links</h2>
            <nav className="list-none mb-10">
            <ul>
              <li><a href="/help/faq" className="text-white hover:text-gray-400">FAQs</a></li>
              <li><a href="https://forms.gle/pt66q2bUquteTogk9" className="text-white hover:text-gray-400">Need Help</a></li>
              <li><a href="https://forms.gle/cMsCUUoi3F3qUdis6" className="text-white hover:text-gray-400">Bulk Enquiry</a></li>
              <li><a href="/sitemap.xml" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-400">View Sitemap</a></li>
              <li><a href="https://forms.gle/LASXWDRuQXVms5wr6" className="text-white hover:text-gray-400">Write Feedback For Us</a></li>
              <li><a href="https://forms.gle/SoegNR1gM9SKEgHK7" className="text-white hover:text-gray-400">Want Offline Distribution</a></li>
              </ul>
            </nav>
          </div>
        <div className="lg:w-1/4 sm:w-1/2 w-full px-2">
          <h2 className="title-font font-medium text-white tracking-widest text-sm mb-3">Contact Us</h2>
          <nav className="list-none mb-5">
          <ul>
            <li><span className="text-white">Need help fast? Fill out <a href="https://forms.gle/gyktuUdKnbUFcjDLA" className="underline">our form </a> and </span></li>
            <li><span className="text-white">Email us on shinzura.com@gmail.com</span></li>
            <li><span className="text-white">Our Address: Govindgarh, Alwar, Rajasthan 301604</span></li>
          </ul>
          </nav>
          <div className="flex space-x-4">
            <a href="https://www.facebook.com/profile.php?id=61573879312290" aria-label="Facebook" >
              <svg className="w-6 h-6 text-white hover:text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
              </svg>
            </a>
            <a href="https://x.com/Shinzura_in" aria-label="twitter">
              <svg className="w-6 h-6 text-white hover:text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"></path>
              </svg>
            </a>
            <a href="https://www.instagram.com/shinzuracare/" aria-label="Instagram">
              <svg className="w-6 h-6 text-white hover:text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
              </svg>
            </a>
            <a href="https://www.linkedin.com/in/shinzura/" aria-label="LinkedIn">
              <svg className="w-6 h-6 text-white hover:text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
              </svg>
            </a>
            <a href="https://www.youtube.com/@Shinzura_care" aria-label="YouTube">
              <svg className="w-6 h-6 text-white hover:text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19.6 3.2H4.4C3.1 3.2 2 4.3 2 5.6v12.8c0 1.3 1.1 2.4 2.4 2.4h15.2c1.3 0 2.4-1.1 2.4-2.4V5.6c0-1.3-1.1-2.4-2.4-2.4zM10 16V8l6 4-6 4z"></path>
              </svg>
            </a>
            <a href="https://in.pinterest.com/shinzuracare/" aria-label="Pinterest">
              <svg className="w-6 h-6 text-white hover:text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.34 2 11.5c0 3.93 2.57 7.26 6.17 8.44-.09-.72-.17-1.83.04-2.62.18-.66 1.17-4.45 1.17-4.45s-.3-.61-.3-1.51c0-1.41.82-2.47 1.84-2.47.87 0 1.29.65 1.29 1.43 0 .87-.56 2.17-.85 3.38-.25 1.03.52 1.86 1.54 1.86 1.85 0 3.27-1.95 3.27-4.76 0-2.48-1.79-4.23-4.34-4.23-2.96 0-4.7 2.22-4.7 4.52 0 .9.35 1.86.79 2.38a.32.32 0 01.07.3c-.08.33-.26 1.03-.3 1.18-.05.2-.16.25-.37.15-1.38-.64-2.24-2.64-2.24-4.26 0-3.46 2.51-6.64 7.23-6.64 3.79 0 6.73 2.7 6.73 6.3 0 3.77-2.37 6.81-5.66 6.81-1.11 0-2.15-.57-2.51-1.25l-.68 2.58c-.25.98-.93 2.21-1.39 2.96C9.91 22.93 10.94 23 12 23c5.52 0 10-4.34 10-9.5S17.52 2 12 2z"></path>
              </svg>
            </a>
          </div>

        </div>
      </div>
    </div>
    <div className="bg-black text-white py-4 px-4 border-t border-gray-400">
      <p>&copy; 2025 Shinzura (Next Unicorn Technologies). All rights reserved.</p>
    </div>
    <KnowMoreAboutShinzura/>
  </footer>
    
  );
};

export default Footer;
